import { I18N } from '@vista-digital/i18n';
export class OccI18N extends I18N {
    constructor(languageTag, cinemaChainName, locale, taxMode) {
        super({
            languageTag: languageTag,
            currency: locale.currency,
            number: locale.number,
            date: locale.date,
            personName: locale.personName,
            monetaryValue: { taxMode }
        });
        this.template = (template, parameters, options) => {
            return super.template(template, Object.assign(Object.assign({}, parameters), { cinemaChainName: this.cinemaChainName }), options);
        };
        this.cinemaChainName = cinemaChainName;
        this.personNameListSeparator = locale.personName.listSeparator;
    }
    translatable(text) {
        if (!text || typeof text === 'string')
            return text;
        return super.translatable(text);
    }
    compareTranslatable(a, b) {
        const aTranslated = this.translatable(a);
        const bTranslated = this.translatable(b);
        return aTranslated.localeCompare(bTranslated);
    }
    personNameList(names) {
        return names.map(name => this.personName(name)).join(this.personNameListSeparator);
    }
    displayTextLabel(label, params, options) {
        if (!label)
            return;
        if (!Array.isArray(label))
            return this.displayTextLabelPart(label, params, options);
        return label.map(part => this.displayTextLabelPart(part, params, options));
    }
    displayTextLabelPart(part, params, options) {
        if (typeof part === 'string')
            return this.template(part, params, options);
        return Object.assign(Object.assign({}, part), { text: this.template(part.text, params, options) });
    }
}
//# sourceMappingURL=i18n.js.map